(() => {
  if (customElements.get('ys-t5-decision-compare')) return;

  class YesoulT5DecisionCompare extends HTMLElement {
    connectedCallback() {
      this.dispose();
      this.controller = new AbortController();
      this.select = this.querySelector('[data-ys-tdc-select]');
      if (!this.select) return;
      this.dataset.ysTdcReady = '';
      this.select.value = this.dataset.ysTdcCompetitor === 'nordictrack' ? 'nordictrack' : 'peloton';
      this.select.addEventListener('change', () => {
        this.dataset.ysTdcCompetitor = this.select.value === 'nordictrack' ? 'nordictrack' : 'peloton';
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.dispose();
    }

    dispose() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      this.select = null;
    }
  }

  customElements.define('ys-t5-decision-compare', YesoulT5DecisionCompare);
})();
